
import { defineComponent } from 'vue';
import useCapabilities from '@/resources/capabilities';
import * as yup from 'yup';
import useFormValidation from '@/resources/form';
import { useField } from 'vee-validate';
import VButton from '@/components/vendor/basic/button/VButton.vue';
import { mapState } from 'vuex';
import VModal from '@/components/vendor/modal/VModal.vue';
import ModalHeader from '@/components/vendor/modal/ModalHeader.vue';
import ModalTitle from '@/components/vendor/modal/ModalTitle.vue';
import ModalBody from '@/components/vendor/modal/ModalBody.vue';
import ModalFooter from '@/components/vendor/modal/ModalFooter.vue';
import Video from '@/api/objects/Video';
import api from '@/api';
import Category from '@/api/objects/Category';

import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'TheAdminVideoDestroy',
  components: {
    ModalFooter,
    ModalBody,
    ModalTitle,
    ModalHeader,
    VModal,
    VButton,
  },
  emits: ['closed', 'videoDestroyed'],
  computed: {
    ...mapState('app', ['formsSettings']),
  },
  props: {
    video: {
      type: Video,
      required: true,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const rules = yup.object({
      name: yup.string()
        .required()
        .label(t('Nombre')),
      description: yup.string()
        .nullable()
        .label(t('Descripción')),
      categories: yup.array()
        .required()
        .min(1)
        .label(t('Categoría')),
      visibility: yup.string()
        .required()
        .label(t('Visibilidad')),
      url: yup.string()
        .required()
        .label(t('Url')),
    });

    const initialValues: Record<string, any> = {
      name: props.video.name,
      description: props.video.description,
      categories: props.video.categories,
      visibility: props.video.visibility,
      url: props.video.url,
    };

    const form = useFormValidation(rules, initialValues);

    const { value: name } = useField('name');
    const { value: description } = useField('description');
    const { value: categories } = useField<[]>('categories');
    const { value: visibility } = useField('visibility');
    const { value: url } = useField('url');

    return {
      ...form,

      name,
      description,
      categories,
      visibility,
      url,

      ...useCapabilities(),
    };
  },
  data() {
    return {
      loadingCategories: false as boolean,
      categoryOptions: [] as Category[],
    };
  },
  async created() {
    await this.loadCategories();
    await this.setCategories();
  },
  methods: {
    async loadCategories() {
      try {
        this.loadingCategories = true;

        this.categoryOptions = await api.admin.videoCategory.all();

        this.loadingCategories = false;
      } catch (e: any) {
        this.loadingCategories = false;

        // TODO: Handle possible exceptions
        this.$toast.error(e.response?.data?.message);
      }
    },
    async setCategories() {
      const categoriesAux: any = [];

      this.categories.forEach((category: string) => {
        const categoryFound = this.categoryOptions.find((o) => o.name === category);

        if (!!categoryFound) {
          categoriesAux.push(categoryFound.id);
        }
      });

      this.categories = categoriesAux;
    },
    async destroyVideo() {
      this.toggleAccepted();

      try {
        // TODO: Send the request to update that video
        await api.admin.video.delete(this.video.id);

        await this.$modal.info({
          title: this.$t('Vídeo eliminado'),
          text: this.$t('Se ha eliminado el vídeo con éxito.'),
        });

        this.toggleAccepted();

        this.$emit('videoDestroyed');
        this.closeModal();
        await this.$router.push({ name: 'admin.video.index' });
      } catch (e) {
        // TODO: Handle possible exceptions
        this.$toast.error(e.response?.data?.message);

        this.toggleAccepted();
      }
    },
    closeModal() {
      this.$emit('closed');
    },
  },
});
